import React, { createContext, useContext, useState, ReactNode } from 'react';

interface IntakeModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
}

const IntakeModalContext = createContext<IntakeModalContextType | undefined>(
  undefined,
);

export const useIntakeModalContext = () => {
  const context = useContext(IntakeModalContext);
  if (context === undefined) {
    throw new Error(
      'useIntakeModalContext must be used within an IntakeModalProvider',
    );
  }
  return context;
};

interface IntakeModalProviderProps {
  children: ReactNode;
}

export const IntakeModalProvider: React.FC<IntakeModalProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const toggleModal = () => setIsOpen(!isOpen);

  const value: IntakeModalContextType = {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };

  return (
    <IntakeModalContext.Provider value={value}>
      {children}
    </IntakeModalContext.Provider>
  );
};

export default IntakeModalProvider;
